"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LootTable_1 = __importDefault(require("../../../../structures/LootTable"));
const SimpleMonster_1 = __importDefault(require("../../../../structures/SimpleMonster"));
const HerbDropTable_1 = __importDefault(require("../../../subtables/HerbDropTable"));
const RareDropTable_1 = require("../../../subtables/RareDropTable");
const RareSeedTable_1 = __importDefault(require("../../../subtables/RareSeedTable"));
const GreaterNechryaelTable = new LootTable_1.default()
    .every('Ashes')
    /* Weapons and armor */
    .add('Adamant kiteshield', 1, 7)
    .add('Rune axe', 1, 7)
    .add('Rune sq shield', 1, 7)
    .add('Adamant battleaxe', 1, 5)
    .add('Rune med helm', 1, 4)
    .add('Rune full helm', 1, 3)
    .add('Mystic air staff', 1, 2)
    .add('Rune boots', 1, 1)
    .add('Rune chainbody', 1, 1)
    /* Runes */
    .add('Death rune', 23, 12)
    .add('Blood rune', 20, 10)
    .add('Chaos rune', 50, 10)
    .add('Air rune', 150, 6)
    .add('Soul rune', 25, 5)
    /* Herbs */
    .add(HerbDropTable_1.default, 1, 7)
    /* Seeds */
    .add(RareSeedTable_1.default, 2, 5)
    /* Other */
    .add('Lobster', 1, 10)
    .add('Coins', [2000, 2500], 8)
    .add('Gold bar', 5, 7)
    .add('Tuna', 2, 6)
    .add('Wine of zamorak', 3, 2)
    /* Gem drop table */
    .add(RareDropTable_1.GemTable, 1, 3)
    /* Tertiary */
    .tertiary(128, 'Clue scroll (hard)');
exports.default = new SimpleMonster_1.default({
    id: 7278,
    name: 'Greater Nechryael',
    table: GreaterNechryaelTable,
    aliases: ['greater nechryael', 'greater nech', 'greater nechs', 'g nechs']
});
//# sourceMappingURL=GreaterNechryael.js.map